export const cardLock = {
    specificLockInfo: 'cards.shared.settings.reissue.lock.infoForSK',
};
